export default {
  englishTitleField: {
    marginBottom: 50,
  },
};
